import React from 'react';

export const SendingText = () => {
    return(
        <div className="row justify-content-center">
            <span className="fa fa-spinner fa-pulse fa-3x fa-fw text-primary"></span>
            <p>Sending Audio. . .</p>
        </div>
    );
};

export const LoadingText = () => {
    return(
        <div className="row justify-content-center">
            <span className="fa fa-spinner fa-pulse fa-3x fa-fw text-primary"></span>
            <p>Loading Text. . .</p>
        </div>
    );
};

export const SendingAudio = () => {
    return(
        <div className="row justify-content-center">
            <span className="fa fa-spinner fa-pulse fa-3x fa-fw text-primary"></span>
            <p>Sending Result. . .</p>
        </div>
    );
};

export const LoadingAudio = () => {
    return(
        <div className="row justify-content-center">
            <span className="fa fa-spinner fa-pulse fa-3x fa-fw text-primary"></span>
            <p>Loading Audio. . .</p>
        </div>
    );
};